export const handleValidation = (form) => {
    const requiredFields = form.querySelectorAll(".js-required");
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    requiredFields.forEach(field => field.classList.remove("error"));

    let formIsValid = true;

    requiredFields.forEach((field) => {
        const input = field.querySelector(".js-input:not(.js-hide):not(.has-uploads)");
        if (!input) return;

        const value = input.value.trim();
        let valid = true;

        if (input.tagName === "SELECT" && !value) valid = false;

        if (input.type !== "checkbox" && !value) {
            valid = false;
        }

        if (input.type === "checkbox" && !input.checked) {
            valid = false;
        }

        if (input.type === "email" && value && !emailPattern.test(value)) {
            valid = false;
        }

        if (!valid) {
            field.classList.add("error");
            formIsValid = false;
        }
    });

    return formIsValid;
};
